import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "language__label" }
const _hoisted_2 = {
  key: 0,
  class: "language__list"
}
const _hoisted_3 = ["onClick"]

import { ref } from 'vue'
import {
  WEGLOT_LANGS,
  weglotInitialized,
  getLanguageName,
} from '@/services/weglot'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const showLanguages = ref<boolean>(false)
const languageText = ref<string>('Language')

const toggleLanguages = (): void => {
  showLanguages.value = !showLanguages.value
}

function currentLanguage(): string {
  if (weglotInitialized()) {
    return window.Weglot.getCurrentLang()
  }
  return ''
}

function switchLanguage(language: string): void {
  if (weglotInitialized()) {
    window.Weglot.switchTo(language)
    Mixpanel.trackLanguageSwitch(language)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["language__container", { 'language__container--expanded': showLanguages.value }]),
    onClick: toggleLanguages
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "language__icon iconfont itranslate" }, null, -1)),
      _createElementVNode("div", null, _toDisplayString(languageText.value), 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "language__icon language__icon--expand iconfont iarrow-down" }, null, -1))
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (showLanguages.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEGLOT_LANGS), (language) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: language,
                  class: _normalizeClass(["language__item wg-no-translate", {
            'language__item--highlighted': language === currentLanguage(),
          }])
                }, [
                  _createElementVNode("button", {
                    class: "language__btn",
                    onClick: ($event: any) => (switchLanguage(language))
                  }, _toDisplayString(_unref(getLanguageName)(language)), 9, _hoisted_3)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})